import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import axios from 'axios';
import { assign, anyPass, exists, promisedReduce } from './utils';
import { isString, isEmpty, omit, toNumber, partial, negate, constant, stubTrue, forEach, includes, get, inRange, cond } from 'lodash';
export var CancelToken = axios.CancelToken;
var isCancel = axios.isCancel; // check for an invalid config

var isInvalidConfig = anyPass([function (v) {
  return v == null;
}, function (val) {
  return !isString(get(val, 'baseURL'));
}, function (val) {
  return isEmpty(get(val, 'baseURL'));
}]); // the default headers given to axios

export var DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}; // the default configuration for axios, default headers will also be merged in

var DEFAULT_CONFIG = {
  timeout: 0
};
export var NONE = null;
export var CLIENT_ERROR = 'CLIENT_ERROR';
export var SERVER_ERROR = 'SERVER_ERROR';
export var TIMEOUT_ERROR = 'TIMEOUT_ERROR';
export var CONNECTION_ERROR = 'CONNECTION_ERROR';
export var NETWORK_ERROR = 'NETWORK_ERROR';
export var UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export var CANCEL_ERROR = 'CANCEL_ERROR';
var TIMEOUT_ERROR_CODES = ['ECONNABORTED'];
var NODEJS_CONNECTION_ERROR_CODES = ['ENOTFOUND', 'ECONNREFUSED', 'ECONNRESET'];

var within = function within(min, max) {
  return function (num) {
    return inRange(num, min, max);
  };
};

var in200s = within(200, 299);
var in400s = within(400, 499);
var in500s = within(500, 599);
/**
 * @typedef {Object} ApiClientResponse
 * @prop {Object}      data - The response response payload
 * @prop {String|null} problem - Problem code
 * @prop {Boolean}     ok - Within 200s status codes
 * @prop {Number}      duration - Time took to get response
 * @prop {Number}      status - HTTP Status Code
 * @prop {Object[]}    headers - Headers used for the request
 * @prop {Object}      config - The axios config
 */

/**
 * @callback ApiClientRequest
 * @param {String} url - The relative url
 * @param {Object} [params] - Query params to be serialized into the url
 * @param {Object} [axiosConfig] - An axios config, for further options
 * @return {Promise<ApiClientResponse>}
 */

/**
 * @callback ApiClientRequestWithBody
 * @param {String} url - The relative url
 * @param {Object} [data] - Payload of the request
 * @param {Object} [axiosConfig] - An axios config, for further options
 * @return {Promise<ApiClientResponse>}
 */

/**
 * @callback ApiClientAddMonitor
 * @param {Function} monitor
 * @return {void}
 */

/**
 * @callback ApiClientRequestInterceptor
 * @param {ApiClient} requestConfig
 * @return {ApiClient}
 */

/**
 * @callback ApiClientAddRequestInterceptor
 * @param {ApiClientRequestInterceptor} requestInterceptor
 * @return {void}
 */

/**
 * @callback ApiClientResponseInterceptor
 * @param {ApiClient} responseConfig
 * @return {ApiClient}
 */

/**
 * @callback ApiClientAddResponseInterceptor
 * @param {ApiClientResponseInterceptor} responseInterceptor
 * @return {void}
 */

/**
 * @callback ApiClientSetHeader
 * @param {String} name
 * @param {Object} value
 * @return {void}
 */

/**
 * @callback ApiClientSetHeaders
 * @param {Object} headers - An object, key as header name and value as value.
 * @return {void}
 */

/**
 * @callback ApiClientSetHeaders
 * @param {Object} headers - An object, key as header name and value as value.
 * @return {void}
 */

/**
 * @callback ApiClientAxiosRequest
 * @param {Object} axiosConfig - An axios config.
 * @return {void}
 */

/**
 * HTTP API Client
 * @typedef {Object} ApiClient
 * @prop {Object}                          axiosInstance
 * @prop {Array}                           monitors
 * @prop {Array}                           requestInterceptors
 * @prop {Array}                           responseInterceptors
 * @prop {Array}                           headers
 * @prop {ApiClientAddMonitor}             addMonitor
 * @prop {ApiClientAddRequestInterceptor}  addRequestInterceptor
 * @prop {ApiClientAddResponseInterceptor} addResponseInterceptor
 * @prop {ApiClientSetHeader}              setHeader
 * @prop {ApiClientSetHeaders}             setHeaders
 * @prop {ApiClientAxiosRequest}           request
 * @prop {ApiClientRequest}                get
 * @prop {ApiClientRequest}                delete
 * @prop {ApiClientRequest}                head
 * @prop {ApiClientRequest}                options
 * @prop {ApiClientRequestWithBody}        post
 * @prop {ApiClientRequestWithBody}        put
 * @prop {ApiClientRequestWithBody}        patch
 * @prop {ApiClientRequestWithBody}        link
 * @prop {ApiClientRequestWithBody}        unlink
 */

/**
 * Creates a instance of our API using the configuration.

 * @param {String}                        config.baseURL -
 *                                        Prepended to `url` unless `url` is absolute.
 * @param {Object}                        [config.headers] -
 *                                        Custom headers to be sent.
 * @param {Number}                        [config.timeout] -
 *                                        Milliseconds before the request times out.
 * @param {Boolean}                       [config.withCredentials] -
 *                                        Indicates whether or not cross-site Access-Control requests should be made using credentials.
 * @param {String}                        [config.responseType] -
 *                                        Type of data that the server will respond with options are 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'.
 * @param {String}                        [config.xsrfCookieName] -
 *                                        Name of the cookie to use as a value for xsrf token.
 * @param {String}                        [config.xsrfHeaderName] -
 *                                        Name of the http header that carries the xsrf token value.
 * @param {Number}                        [config.maxContentLength] -
 *                                        Max size of the http response content allowed.
 * @param {config}                        [config.adapter] -
 *                                        Custom handling of requests which makes testing easier. See axios adapter docs.
 * @param {CancelToken}                   [config.cancelToken] -
 *                                        Cancel token that can be used to cancel the request
 * @param {{data}|{data}[]}               [config.transformRequest] -
 *                                        Changes to the request data before it is sent to the server. Almost always opt for api-client API instead.
 * @param {{data}|{data}[]}               [config.transformResponse] -
 *                                        Changes to the response data before it is passed to then. Almost always opt for api-client API instead.
 * @param {{username,password}}           [config.auth] -
 *                                        HTTP Basic auth. Sets an `Authorization` header, overwriting any existing.
 * @param {{host,port,auth}}              [config.proxy] -
 *                                        Hostname, port and auth of the proxy server. Sets `Proxy-Authorization` header, overwriting any existing header.
 * @param {(params: any) => String}       [config.paramsSerializer] -
 *                                        Function to serialize `params`.
 * @param {(progressEvent: any) => void}  [config.onUploadProgress] -
 *                                        Handling of progress events for uploads.
 * @param {(progressEvent: any) => void}  [config.onDownloadProgress] -
 *                                        Handling of progress events for downloads.
 * @param {(status: Number) => Boolean}   [config.validateStatus] -
 *                                        Resolve or reject the promise for a given HTTP response. Almost always opt for api-client API instead.
 * @param {Number}                        [config.maxRedirects] -
 *                                        (nodejs) Maximum number of redirects to follow.
 * @param {Object}                        [config.httpAgent] -
 *                                        (nodejs) New `http.Agent`.
 * @param {Object}                        [config.httpsAgent] -
 *                                        (nodejs) New `https.Agent`.
 * @return {ApiClient} HTTP API Client
 */

export function create(config) {
  // quick sanity check
  if (isInvalidConfig(config)) throw new Error('config must have a baseURL'); // combine the user's defaults with ours

  var headers = assign({}, DEFAULT_HEADERS, config.headers || {});
  var combinedConfig = assign({}, DEFAULT_CONFIG, omit(config, 'headers')); // create the axios instance

  var instance = axios.create(combinedConfig);
  var monitors = [];

  var addMonitor = function addMonitor(monitor) {
    monitors.push(monitor);
  };

  var requestInterceptors = [];
  var responseInterceptors = [];

  var addRequestInterceptor = function addRequestInterceptor(transform) {
    return requestInterceptors.push(transform);
  };

  var addResponseInterceptor = function addResponseInterceptor(transform) {
    return responseInterceptors.push(transform);
  }; // convenience for setting new request headers


  var setHeader = function setHeader(name, value) {
    headers[name] = value;
    return instance;
  }; // sets headers in bulk


  var setHeaders = function setHeaders(headers) {
    var keys = _Object$keys(headers);

    forEach(keys, function (header) {
      return setHeader(header, headers[header]);
    });
    return instance;
  };
  /**
   Make the request for GET, HEAD, DELETE
   */


  var doRequestWithoutBody = function doRequestWithoutBody(method, url) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var axiosConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return doRequest(assign({}, {
      url: url,
      params: params,
      method: method
    }, axiosConfig));
  };
  /**
   Make the request for POST, PUT, PATCH
   */


  var doRequestWithBody = function doRequestWithBody(method, url) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var axiosConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return doRequest(assign({}, {
      url: url,
      method: method,
      data: data
    }, axiosConfig));
  };

  var interceptorReduce = function interceptorReduce(payload, intercept) {
    return intercept(payload);
  };
  /**
   Make the request with this config!
   */


  var doRequest = function doRequest(requestConfig) {
    // 'url', 'method', 'data', 'headers', 'params', ...other axios config
    requestConfig.headers = _objectSpread({}, headers, {}, requestConfig.headers);
    var startedAt = toNumber(new Date());
    var normaliseResponse = partial(convertResponse, startedAt);

    var monitorsResponseInterceptors = _concatInstanceProperty(responseInterceptors).call(responseInterceptors, runMonitors); // prepare interceptors


    var interceptRequest = function interceptRequest() {
      return promisedReduce(requestInterceptors, interceptorReduce, assign({}, requestConfig));
    };

    var interceptResponse = function interceptResponse(response) {
      return promisedReduce(monitorsResponseInterceptors, interceptorReduce, assign({}, response));
    }; // bam bam bam bam bam bam


    return interceptRequest().then(instance.request).then(normaliseResponse).catch(normaliseResponse).then(interceptResponse);
  };
  /**
   Fires after we convert from axios' response into our response.  Exceptions
   raised for each monitor will be ignored.
   */


  var runMonitors = function runMonitors(ourResponse) {
    _forEachInstanceProperty(monitors).call(monitors, function (fn) {
      try {
        fn(ourResponse);
      } catch (error) {// all monitor complaints will be ignored
      }
    });

    return ourResponse;
  };

  var isResponseError = function isResponseError(err) {
    return err instanceof Error || isCancel(err);
  };
  /**
   Converts an axios response/error into our response.
   */


  var convertResponse = function convertResponse(startedAt, axiosResponse) {
    var end = toNumber(new Date());
    var duration = end - startedAt; // new in Axios 0.13 -- some data could be buried 1 level now

    var isError = isResponseError(axiosResponse);
    var response = isError ? axiosResponse.response : axiosResponse;
    var status = response && response.status ? response.status : null;
    var problem = isError ? getProblemFromError(axiosResponse) : getProblemFromStatus(status);
    var ok = in200s(status);
    var config = axiosResponse.config || null;
    var headers = response && response.headers ? response.headers : null;
    var data = response && response.data ? response.data : null;
    return {
      duration: duration,
      problem: problem,
      ok: ok,
      status: status,
      headers: headers,
      config: config,
      data: data
    };
  };
  /**
   What's the problem for this response?
   TODO: We're losing some error granularity, but i'm cool with that
   until someone cares.
   */


  var getProblemFromError = function getProblemFromError(error) {
    // first check if the error message is Network Error (set by axios at 0.12) on platforms other than NodeJS.
    if (error.message === 'Network Error') return NETWORK_ERROR; // then check if the request was cancelled manually

    if (isCancel(error)) return CANCEL_ERROR; // then check the specific error code

    return cond([// if we don't have an error code, we have a response status
    [negate(exists), function () {
      return getProblemFromStatus(error.response.status);
    }], [partial(includes, TIMEOUT_ERROR_CODES), constant(TIMEOUT_ERROR)], [partial(includes, NODEJS_CONNECTION_ERROR_CODES), constant(CONNECTION_ERROR)], [stubTrue, constant(UNKNOWN_ERROR)]])(error.code);
  };
  /**
   * Given a HTTP status code, return back the appropriate problem enum.
   */


  var getProblemFromStatus = function getProblemFromStatus(status) {
    return cond([[function (v) {
      return !exists(v);
    }, constant(UNKNOWN_ERROR)], [in200s, constant(NONE)], [in400s, constant(CLIENT_ERROR)], [in500s, constant(SERVER_ERROR)], [stubTrue, constant(UNKNOWN_ERROR)]])(status);
  }; // create the base object


  var sauce = {
    axiosInstance: instance,
    monitors: monitors,
    addMonitor: addMonitor,
    requestInterceptors: requestInterceptors,
    responseInterceptors: responseInterceptors,
    addRequestInterceptor: addRequestInterceptor,
    addResponseInterceptor: addResponseInterceptor,
    setHeader: setHeader,
    setHeaders: setHeaders,
    headers: headers,
    request: doRequest,
    get: partial(doRequestWithoutBody, 'get'),
    delete: partial(doRequestWithoutBody, 'delete'),
    head: partial(doRequestWithoutBody, 'head'),
    options: partial(doRequestWithoutBody, 'options'),
    post: partial(doRequestWithBody, 'post'),
    put: partial(doRequestWithBody, 'put'),
    patch: partial(doRequestWithBody, 'patch'),
    link: partial(doRequestWithoutBody, 'link'),
    unlink: partial(doRequestWithoutBody, 'unlink')
  }; // send back the sauce

  return sauce;
}
export default {
  DEFAULT_HEADERS: DEFAULT_HEADERS,
  NONE: NONE,
  CLIENT_ERROR: CLIENT_ERROR,
  SERVER_ERROR: SERVER_ERROR,
  TIMEOUT_ERROR: TIMEOUT_ERROR,
  CONNECTION_ERROR: CONNECTION_ERROR,
  NETWORK_ERROR: NETWORK_ERROR,
  UNKNOWN_ERROR: UNKNOWN_ERROR,
  CANCEL_ERROR: CANCEL_ERROR,
  CancelToken: CancelToken,
  create: create
};